import React, { useState, useEffect, useRef } from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Field } from 'formik';
import ValidatedFormInputField from '../../../../../core-components/ValidatedFormInputField';
import ValidatedRadioFields from '../../../../../core-components/ValidatedRadioFields';
import Checkbox from '../../../../../core-components/Checkbox';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileInput from '../../../../../core-components/FileInput/FileInput';
import styles from './EmailContent.module.scss';
import { getTrimmedValue } from '../../../../../utils/utilities';
import Image from '../../../../../core-components/Image/Image';

export default function EmailContent(props) {
  const { values, setFieldValue, profile, formConfig } = props;
  const previousStateValues = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isCorrectLogoFormat, setIsCorrectLogoFormat] = useState(true);

  const hrNoteCount =
    values?.hrInviteNoteDefaultOrCustom == 1
      ? values?.defaultHrInviteNote.trim().length
      : values?.hrInviteNote?.trim()?.length;
  const hrWarningNoteCount =
    values?.hrWarningNoteDefaultOrCustom == 1
      ? values?.defaultHrWarningNote.trim().length
      : values?.hrWarningNote?.trim()?.length;

  const [hrInviteNoteRadioOptions, setHrInviteNoteRadioOptions] = useState([
    { value: '1', label: 'Default', disable: true },
    { value: '2', label: 'Custom', disable: true }
  ]);
  const [hrWarningNoteRadioOptions, setHrWarningNoteRadioOptions] = useState([
    { value: '1', label: 'Default', disable: true },
    { value: '2', label: 'Custom', disable: true }
  ]);

  const lastSettingValidation = () => {
    if (
      formConfig?.company?.friendlyName === values?.friendlyName &&
      formConfig?.hrInviteNote === values?.hrInviteNote &&
      formConfig?.hrWarningNote === values?.hrWarningNote &&
      formConfig?.hrInviteNoteStatus === values?.hrInviteNoteStatus &&
      formConfig?.hrWarningNoteStatus === values?.hrWarningNoteStatus &&
      formConfig?.company?.logoUrl === values?.logoUrl &&
      formConfig?.company?.useLogoInInviteMail === values?.useLogoInInviteMail &&
      previousStateValues?.current?.hrInviteNoteDefaultOrCustom ==
        values?.hrInviteNoteDefaultOrCustom &&
      previousStateValues?.current?.hrWarningNoteDefaultOrCustom ==
        values?.hrWarningNoteDefaultOrCustom
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isValidForm =
    (hrNoteCount >= 10 && hrNoteCount <= 160 ? true : false) &&
    (hrWarningNoteCount >= 10 && hrWarningNoteCount <= 160 ? true : false) &&
    !isUploading &&
    values?.isImgLoaded &&
    values?.logoEnabled &&
    !lastSettingValidation();

  useEffect(() => {
    props.getCandidateFormConfig();
  }, []);

  useEffect(() => {
    const prevValue = {
      hrInviteNoteDefaultOrCustom:
        props?.formConfig?.hrInviteNote === values?.defaultHrInviteNote ? 1 : 2,
      hrWarningNoteDefaultOrCustom:
        props?.formConfig?.hrWarningNote === values?.defaultHrWarningNote ? 1 : 2
    };
    previousStateValues.current = prevValue;
  }, [props.formConfig]);

  useEffect(() => {
    props.setEmailContentData(values);
    props.isValidForm(isValidForm);

    if (!values.logoEnabled) {
      setFieldValue('useLogoInInviteMail', false);
    }

    if (values.hrInviteNoteStatus) {
      setHrInviteNoteRadioOptions([
        { value: '1', label: 'Default' },
        { value: '2', label: 'Custom' }
      ]);
    } else {
      //To remove the default selected, I am making the values as 3 and 4
      setFieldValue('hrInviteNoteDefaultOrCustom', 1);
      setHrInviteNoteRadioOptions([
        { value: '3', label: 'Default', disable: true },
        { value: '4', label: 'Custom', disable: true }
      ]);
    }

    if (values.hrWarningNoteStatus) {
      setHrWarningNoteRadioOptions([
        { value: '1', label: 'Default' },
        { value: '2', label: 'Custom' }
      ]);
    } else {
      //To remove the default selected, I am making the values as 3 and 4
      setFieldValue('hrWarningNoteDefaultOrCustom', 1);
      setHrWarningNoteRadioOptions([
        { value: '3', label: 'Default', disable: true },
        { value: '4', label: 'Custom', disable: true }
      ]);
    }
  }, [values, isValidForm]);

  const onImgLoadLogoFile = ({ target: img }) => {
    setFieldValue('isImgLoaded', true);
    if (img.naturalHeight < 60) {
      setFieldValue('logoEnabled', false);
    } else {
      setFieldValue('logoEnabled', true);
    }
  };

  return (
    <div className={styles.emailContentWrapper}>
      <Form>
        <div className={styles.sectionHeader}>
          Brand Name
          <OverlayTrigger
            key={`password_protected`}
            placement='top'
            style
            overlay={
              <Tooltip id={`password_protected`} style={{ width: '200px' }}>
                <p>Add your brand name so candidates can easily recognise this email.</p>
              </Tooltip>
            }
          >
            <Image name='info.svg' className={'ml-2'} />
          </OverlayTrigger>
        </div>
        <div style={{ position: 'relative' }}>
          <Field
            component={ValidatedFormInputField}
            type='text'
            name='friendlyName'
            placeholder=''
            onChange={(event) => {
              if (event.target.value.trim().length <= 160) {
                setFieldValue('friendlyName', event.target.value);
              }
            }}
            onBlur={(e) => {
              setFieldValue('friendlyName', getTrimmedValue(e.target.value, true));
            }}
          />
        </div>

        <hr />

        <div style={{ position: 'relative' }}>
          <Form.Group controlId='hrInviteNote'>
            <div className={styles.sectionHeader}>HR Note (In all invite emails)</div>
            <Form.Control
              as='textarea'
              rows={3}
              name='hrInviteNote'
              style={{ resize: 'none' }}
              onInput={(event) => {
                if (event.target.value.trim().length > 160) {
                  event.target.value = event.target.value.trim().slice(0, 160);
                }
              }}
              onBlur={(e) => {
                setFieldValue('hrInviteNote', e.target.value.trim());
              }}
              value={
                values.hrInviteNoteDefaultOrCustom == 1
                  ? values.defaultHrInviteNote
                  : values?.hrInviteNote
              }
              disabled={values.hrInviteNoteDefaultOrCustom != 2}
              placeholder='Type a note...'
              onChange={(e) => {
                setFieldValue('hrInviteNote', e.target.value);
              }}
            />
          </Form.Group>
          <div
            className={styles.hrNoteCharacterLimit}
            style={
              hrNoteCount == 160 || (hrNoteCount < 10 && hrNoteCount > 0)
                ? { color: '#DC3545' }
                : null
            }
          >
            Characters {hrNoteCount} out of 160
          </div>
        </div>

        <div className={styles.customRadioAndCheckGroup}>
          <Field
            custom
            name='hrInviteNoteStatus'
            className={'custom-checkbox-style-1 ' + styles.cBoxMargin}
            component={Checkbox}
            label='Enabled'
          />
          <Field
            name='hrInviteNoteDefaultOrCustom'
            component={ValidatedRadioFields}
            className={'custom-radio-style-1'}
            options={hrInviteNoteRadioOptions}
            onChange={() => {
              if (values.hrInviteNoteDefaultOrCustom == 1) {
                setFieldValue('hrInviteNote', props?.formConfig?.hrInviteNote);
              } else {
                setFieldValue('hrInviteNote', values?.defaultHrInviteNote);
              }
            }}
          />
        </div>
        <hr />
        <div style={{ position: 'relative' }}>
          <Form.Group controlId='hrWarningNote'>
            <div className={styles.sectionHeader}>Overdue Note (In all overdue emails)</div>
            <Form.Control
              as='textarea'
              rows={3}
              style={{ resize: 'none' }}
              name='hrWarningNote'
              onInput={(event) => {
                if (event.target.value.trim().length > 160) {
                  event.target.value = event.target.value.trim().slice(0, 160);
                }
              }}
              onBlur={(e) => {
                setFieldValue('hrWarningNote', e.target.value.trim());
              }}
              value={
                values.hrWarningNoteDefaultOrCustom == 1
                  ? values.defaultHrWarningNote
                  : values?.hrWarningNote
              }
              disabled={values.hrWarningNoteDefaultOrCustom != 2}
              placeholder='Type a note...'
              onChange={(e) => {
                setFieldValue('hrWarningNote', e.target.value);
              }}
            />
          </Form.Group>
          <div
            className={styles.hrNoteCharacterLimit}
            style={
              hrWarningNoteCount == 160 || (hrWarningNoteCount < 10 && hrWarningNoteCount > 0)
                ? { color: '#DC3545' }
                : null
            }
          >
            Characters {hrWarningNoteCount} out of 160
          </div>
        </div>

        <div className={styles.customRadioAndCheckGroup}>
          <Field
            custom
            name='hrWarningNoteStatus'
            className={'custom-checkbox-style-1 ' + styles.cBoxMargin}
            component={Checkbox}
            label='Enabled'
          />
          <Field
            name='hrWarningNoteDefaultOrCustom'
            component={ValidatedRadioFields}
            options={hrWarningNoteRadioOptions}
            className={'custom-radio-style-1'}
            onChange={() => {
              if (values.hrWarningNoteDefaultOrCustom == 1) {
                setFieldValue('hrWarningNote', props?.formConfig?.hrWarningNote);
              } else {
                setFieldValue('hrWarningNote', values?.defaultHrWarningNote);
              }
            }}
          />
        </div>
        <hr />
        <div className={styles.companyLogo}>
          <p>Company logo</p>
          {values.logoUrl && (
            <img
              src={values.logoUrl}
              className={styles.logoUrl}
              onLoad={onImgLoadLogoFile}
              onError={() => {
                setFieldValue('isImgLoaded', false);
              }}
              onClick={() => {
                window.open(values.logoUrl);
              }}
            />
          )}
          <Field
            name='logoFile'
            component={FileInput}
            setIsUploading={setIsUploading}
            uploadToServer={'s3Upload'}
            defaultField={false}
            linkFieldName={'logoUrl'}
            candidateId={profile?.company_user_mapping?.company_id}
            accept='image/jpeg, image/png'
            setIsCorrectLogoFormat={setIsCorrectLogoFormat}
          />
        </div>
        {!values.logoEnabled && isCorrectLogoFormat && (
          <div className={styles.imageSizeText}>Upload an image of size more than 60px</div>
        )}
        {!isCorrectLogoFormat && (
          <div className={styles.imageSizeText}>
            Please provide a valid company logo format (.png, .jpeg, .jpg)
          </div>
        )}
        <div className={styles.useLogoInInviteMail}>
          <Field
            custom
            name='useLogoInInviteMail'
            className={'custom-checkbox-style-1 ' + styles.cBoxMargin}
            component={Checkbox}
            disabled={!values.logoEnabled}
            label='Enable logo in invite email'
          />
        </div>
      </Form>
    </div>
  );
}
